import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function BossierCityProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Bossier City"
      headingExtra="Louisiana"
      introText="Bossier City travelers — Barksdale AFB military families with PCS orders, Louisiana Boardwalk casino professionals heading to Macau, and Bossier Parish families planning international trips — have several options for getting a passport fast. Here is how they compare, and why most Northwest Louisiana residents choose a registered U.S. Department of State passport courier for predictable, professional processing."
      options={options}
      emergencyDescription="New Orleans ~320 mi via I-49/I-10 (5+ hrs). Louisiana has only ONE passport agency (New Orleans) serving 4.6M+ residents. Barksdale AFB is home to Air Force Global Strike Command — military families receiving short-notice PCS orders to overseas bases cannot wait 10+ hours for a round trip to New Orleans. I-20 across northern Louisiana has no alternate route — a single accident or summer thunderstorm adds hours with zero detour. The Red River separates Bossier City from Shreveport with limited bridge crossings during flood events."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. Louisiana has only one passport agency (New Orleans) serving 4.6M+ statewide residents."
    />
  );
}